export default {
  data: [
    {
      id: 1,
      _lft: 1,
      _rgt: 20,
      parent_id: null,
      name: "Education",
      partner_label: "Institution",
      product_label: "Courses",
      type: "master",
      created_at: "2019-11-11 09:37:59",
      updated_at: "2019-11-11 09:37:59"
    },
    {
      id: 11,
      _lft: 21,
      _rgt: 28,
      parent_id: null,
      name: "Visa & Migration",
      partner_label: "Visa Department",
      product_label: "Visa Subclass",
      type: "master",
      created_at: "2019-11-11 09:37:59",
      updated_at: "2019-11-11 09:37:59"
    },
    {
      id: 15,
      _lft: 29,
      _rgt: 46,
      parent_id: null,
      name: "Insurance",
      partner_label: "Insurance Provider",
      product_label: "Insurance Policies",
      type: "master",
      created_at: "2019-11-11 09:37:59",
      updated_at: "2019-11-11 09:37:59"
    },
    {
      id: 24,
      _lft: 47,
      _rgt: 64,
      parent_id: null,
      name: "Accommodation",
      partner_label: "Accommodation Provider",
      product_label: "Accommodation Option",
      type: "master",
      created_at: "2019-11-11 09:38:00",
      updated_at: "2019-11-11 09:38:00"
    },
    {
      id: 33,
      _lft: 65,
      _rgt: 70,
      parent_id: null,
      name: "Short Classes",
      partner_label: "Partner",
      product_label: "Product",
      type: "master",
      created_at: "2019-11-11 09:38:00",
      updated_at: "2019-11-11 09:38:00"
    },
    {
      id: 36,
      _lft: 71,
      _rgt: 78,
      parent_id: null,
      name: "Skill Assessment",
      partner_label: "Partner",
      product_label: "Product",
      type: "master",
      created_at: "2019-11-11 09:38:00",
      updated_at: "2019-11-11 09:38:00"
    },
    {
      id: 40,
      _lft: 79,
      _rgt: 84,
      parent_id: null,
      name: "Other Services",
      partner_label: "Partner",
      product_label: "Product",
      type: "master",
      created_at: "2019-11-11 09:38:00",
      updated_at: "2019-11-11 09:38:00"
    }
  ]
};
